import { Directive, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { SellerLogoManagerService } from '../../_services/sellerLogoManagerService';

@Directive({
    selector: '[sellerLogoImage]',
    host: {
        '(error)': 'updateUrl()',
        '[src]': 'src'
    }
})
export class SellerLogoImageDirective implements OnInit, OnDestroy {
    @Input() src: string;
    @Input() sellerlogo: string;

    constructor(
        private elementRef: ElementRef,
        private sellerLogoManagerService: SellerLogoManagerService
    ) {
    }

    ngOnInit() {
        const logoObj = this.sellerLogoManagerService.initLogo(this.sellerlogo);
        this.src = logoObj.path;
        this.elementRef.nativeElement.classList.add(logoObj.elementClass);
    }

    ngOnDestroy() {
    }

    updateUrl() {
        this.src = 'assets/icon/default_cpg.png';
    }

}